import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export interface IAdvertiserProps {
    companyName: string,
    erid: string,
}

/**
 * Информация о рекламодателе
 */
export const Advertiser = ({ companyName, erid }: IAdvertiserProps) => (
    <Paragraph5 $color={COLORS.TextWhite}>
        {companyName}
        <br />
        erid: {erid}
    </Paragraph5>
);
